import styled from "styled-components";

export const DirectoryContainer = styled.div`
      width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill,minmax(350px,1fr));
  }
`;
